import React from 'react'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { truncateString } from '../../../../services/helpers'
import { useVisualisationsState } from '../../../contexts/visualisations-context'
import { StatusMap } from '../../../../enum/CreateCartoMaps'
import Spinner from '../../../presentation/spinner'
import './style.css'

const useStyles = makeStyles(() => ({
    customWidth: {
      maxWidth: 200,
    },
}));

const RecentImportsTable = () => {
    const { visualisationsList } = useVisualisationsState()
    const classes = useStyles()


    const renderStatusCell = (vis) => {
        if (vis.status === StatusMap.FAIL.status) {
        const TooltipMessage = () => <span className="tooltip-message">Error creating the visualisation.</span>

            return (
                <td style={{ color: StatusMap.FAIL.color }}>
                    <Tooltip title={<TooltipMessage />} placement="top" classes={{ tooltip: classes.customWidth }}>
                        <div className="center-cell-content">
                            <span>{ StatusMap.FAIL.message }</span>
                            <HelpOutlineIcon style={{ fontSize: 15 }}/>
                        </div>
                    </Tooltip>
                </td>
            )
        }

        return <td style={{ color: StatusMap[vis.status].color }}>{ StatusMap[vis.status].message }</td>
    }

    const renderViewVisualisationButton = (vis) => {
        if (vis.status === StatusMap.COMPLETE.status) {
            return (
                <Button 
                    variant="outlined" 
                    color="primary"
                    onClick={() => window.open(vis.cartoMapUrl, '_blank')}
                >
                     View
                </Button>
            )
        }

        if (
            vis.status === StatusMap.PENDING.status 
            || vis.status === StatusMap.IMPORTING_DATASETS.status 
            || vis.status === StatusMap.CREATING_MAP.status
        ) {
            return <div className="flex-container"><Spinner /></div>
        }
    }

    const arrangeVisualisationsData = (visList) => {
        const arrengedData = visList
            .sort((a, b) => (new Date(b.date)) - (new Date(a.date)))
        
        return arrengedData
    }

    return (
        <table className="maps-list-table">
            <thead>
                <tr>
                    <th className="row-date"><h5>Date</h5></th>
                    <th className="row-name"><h5>Visualisation Name</h5></th>
                    <th className="row-status"><h5>Status</h5></th>
                    <th className="row-zones-imported"><h5>Zones Imported</h5></th>
                    <th className="row-download"></th>
                </tr>
            </thead>
            <tbody>
                {   // Render only files that area not with status COMPLETED
                    arrangeVisualisationsData(visualisationsList).map(vis => {
                        return (
                            <tr key={vis.id}>
                                <td>{ moment(vis.date).format('MMM DD, YYYY HH:mm') }</td>
                                <td>{ truncateString(vis.visualisationName, 60) }</td>
                                { renderStatusCell(vis) } 
                                <td>{ vis.numberOfZones }</td>
                                <td>
                                    { renderViewVisualisationButton(vis) }
                                </td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}

export default RecentImportsTable